import { HTMLText } from '@pixi/text-html';

export default class LocalizedHTMLText extends HTMLText {
  constructor (text, style, identifier = null) {
    super(text, style)
    this.identifier = identifier
    this.resolution = 3
  }
}
